import get from 'transmute/get';
export const getThreadRemovalAudit = get('audit');
export const getThreadRemovalChanges = get('changes');
export const getThreadRemovalMembers = get('members');
export const getThreadRemovalType = get('@type');